import { EntityType } from '../../models/InvestmentEntity';

export const ENTITY_TYPE_OPTIONS: { value: EntityType; label: string }[] = [
  { value: 'INDIVIDUAL', label: 'Individual' },
  { value: 'TRUST', label: 'Trust' },
  { value: 'COMPANY', label: 'Company' },
  { value: 'SMSF', label: 'SMSF' },
  { value: 'PARTNERSHIP', label: 'Partnership' },
];

export const TRUSTEE_VALIDATION_MESSAGES = {
  missingFields: {
    trusteeIndividuals: 'at least one trustee individual is required',
  },
};
